module.exports = __webpack_public_path__ + "img/52800.0a120afd.jpg";